export default "__VITE_ASSET__DfanmV_a__"